import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { noop } from 'lodash';
import Api from 'domain/api';

import { normalizeAgGridColDefs } from 'components/AgGrid/helpers';

const fetchHeaders = async (params = {}) =>
  Api.getDashboardVendorExpensesHeaders({
    params: { period_value: params.value, period_type: params.type },
  });

const useFetchColumnDefs = ({ periodValue = {} }) => {
  const dispatch = useDispatch();

  const [columnDefs, setColumnDefs] = useState([]);
  const [isBusy, setIsBusy] = useState(true);
  const [isFetched, setIsFetched] = useState(false);

  const fetchColumnDefs = useCallback(async () => {
    setIsBusy(true);

    try {
      const { data } = await fetchHeaders(periodValue);
      // remove operator from the columnDefs
      setColumnDefs(normalizeAgGridColDefs(data.map(({ operator, ...item }) => item)));
      setIsFetched(true);
    } finally {
      setIsBusy(false);
    }
  }, [periodValue]);

  useEffect(() => {
    if (!isFetched) {
      fetchColumnDefs().catch(noop);
    }
  }, [fetchColumnDefs, dispatch, isFetched]);

  return {
    rawColumnDefs: columnDefs,
    rawColumnDefsIsBusy: isBusy,
    rawColumnDefsIsFetched: isFetched,
    fetchColumnDefs,
  };
};

export default useFetchColumnDefs;
